import React from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import { SectionTabs, type SectionTab } from "@pgs-core/ui/components/section-tabs";
import type { AdminOutletContext } from "../lib/outlet-context";

// Layout for /infrastructure/* — renders the section heading + tabs, then the
// active sub-page via a nested Outlet (context re-provided for child pages).
export function InfrastructureLayout() {
  const ctx = useOutletContext<AdminOutletContext>();

  const tabs: SectionTab[] = [
    { label: "Overview", href: "/infrastructure", end: true },
    { label: "Database Backup", href: "/infrastructure/database-backup" },
    { label: "Security", href: "/infrastructure/security" },
    { label: "GDPR", href: "/infrastructure/gdpr" },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold tracking-tight">Infrastructure</h1>
      <SectionTabs items={tabs} className="mt-4" />
      <div className="mt-6">
        <Outlet context={ctx} />
      </div>
    </div>
  );
}
